import React from "react";

const RefDataLabel = ({
  label,
  isRefData = false,
  className = "",
}) => {
  return (
    <span className={className}>
      <span
        title={
          isRefData
            ? "This is a Ref.Data field"
            : ""
        }
        style={
          isRefData
            ? {
                border: "1.5px solid #0d6efd",
                background: "#eef5ff",
                color: "#084298",
                padding: "2px 6px",
                borderRadius: "10px",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                fontWeight: "700",
                letterSpacing: "0.3px",
                boxShadow:
                  "0 0 4px rgba(13,110,253,0.2)",
              }
            : {
                fontWeight: "600",
              }
        }
      >
        {label}

        {isRefData && (
          <span
            style={{
              marginLeft: "6px",
              fontSize: "11px",
              background: "#0d6efd",
              color: "white",
              borderRadius: "10px",
              padding: "2px 6px",
              fontWeight: "bold",
            }}
          >
            Ref.Data
          </span>
        )}
      </span>
      
    </span>
  );
};

export default RefDataLabel;